import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

/**
 * HTTP Interceptor for NextBillion.ai API requests
 * Automatically adds API key to requests going to NextBillion endpoints
 */
export const nextBillionApiInterceptor: HttpInterceptorFn = (req, next) => {
  // Check if the request is for NextBillion API
  if (req.url.includes('api.nextbillion.io')) {
    // Clone the request and add the API key as a query parameter
    const modifiedReq = req.clone({
      setParams: {
        key: environment.nextBillion.apiKey,
      },
    });
    return next(modifiedReq);
  }

  // Pass through other requests unchanged
  return next(req);
};
